import type { CluePublic } from '@cloudfruit-hunts/shared';
import { TextClue } from '../clue-types/TextClue';
import { ImageClue } from '../clue-types/ImageClue';
import { CipherClue } from '../clue-types/CipherClue';
import { AudioClue } from '../clue-types/AudioClue';
import { MagnifierClue } from '../clue-types/MagnifierClue';
import { CoordinateClue } from '../clue-types/CoordinateClue';

interface ClueSceneProps {
  clue: CluePublic;
}

export function ClueScene({ clue }: ClueSceneProps) {
  switch (clue.type) {
    case 'text':
      return <TextClue clue={clue} />;

    case 'image':
      return <ImageClue clue={clue} />;

    case 'cipher':
      return <CipherClue clue={clue} />;

    case 'audio':
      return <AudioClue clue={clue} />;

    case 'magnifier':
      return <MagnifierClue clue={clue} />;

    case 'coordinates':
      return <CoordinateClue clue={clue} />;

    case 'stego':
      return <ImageClue clue={clue} />;

    case 'assembly':
      return <TextClue clue={clue} />;

    default:
      return <TextClue clue={clue} />;
  }
}
